import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  ButtonContainer,
  Button,
  FormInput,
  FormInputTextArea
} from 'camino-react'

import { cloudhelpPost } from 'Utilities/CloudHelp'
import Modal from 'Components/Modal'

class BulkMessage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      fields: {
        message: ''
      },
      submitButton: {
        text: 'send',
        disabled: false
      }
    }
  }

  handleInputChange = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })
      return (
        { fields: newFields }
      )
    })
  }

  submitForm () {
    const {
      setAlert,
      paths,
      tickets,
      removeModal
    } = this.props
    const { fields } = this.state
    const { message } = fields
    const { problemCommentsPath } = paths

    this.setState({
      submitButton: {
        text: 'sending...',
        disabled: true
      }
    })

    cloudhelpPost(problemCommentsPath, {
      comment: { content: message, communication_type: 'correspondence' },
      ticket_ids: _.map(tickets, ({ id }) => id)
    })
      .then((response) => {
        this.setState({
          submitButton: {
            text: 'send',
            disabled: false
          },
          fields: {
            message: ''
          }
        })
        removeModal()
        return response
      })
      .catch((error) => {
        this.setState({
          submitButton: {
            text: 'send',
            disabled: false
          }
        })

        const errorArray = []
        errorArray.push(error.response.data.error_flash_message)
        errorArray.push(error.response.data.successful_flash_message)

        setAlert(_.flatten(errorArray), 'error')
      })
      .then((response) => {
        setAlert(response.data.successful_flash_message, 'success')
      })
  }

  render () {
    const { showModal, removeModal } = this.props
    const { fields, submitButton } = this.state
    const { message } = fields
    const { text: submitText, disabled: submitDisabled } = submitButton

    return (
      <Modal
        showModal={showModal}
        title="Send bulk message"
        removeModal={removeModal}
      >
        <FormInput label="Message">
          <FormInputTextArea
            value={message}
            rows="5"
            onValue={value => (this.handleInputChange('message', value))}
          />
        </FormInput>

        <ButtonContainer center spaced>
          <Button outline onClick={removeModal}>
            Cancel
          </Button>
          <Button onClick={() => { this.submitForm() }} disabled={_.isEmpty(message) || submitDisabled}>
            {submitText}
          </Button>
        </ButtonContainer>
      </Modal>
    )
  }
}

BulkMessage.propTypes = {
  tickets: PropTypes.array.isRequired,
  setAlert: PropTypes.func.isRequired,
  paths: PropTypes.shape({
    problemCommentsPath: PropTypes.string.isRequired
  }).isRequired
}

export default BulkMessage
